// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from annotate.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function AnnotateIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M14 0a2 2 0 0 1 2 2v13a1 1 0 0 1-1.555.832l-4.262-1.757A1 1 0 0 0 9.802 14H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zm-2.109 3.5h-.484l-.14.006-.122.018a.684.684 0 0 0-.2.071l-.076.054-.108.1-.097.1-1.632 1.999-.091.12-.084.129a2.56 2.56 0 0 0-.291.722l-.03.142-.027.218-.009.223v2.646l.01.086.027.08a.537.537 0 0 0 .236.236l.067.028.07.016.074.006h2.907l.074-.006.094-.024a.516.516 0 0 0 .169-.108.525.525 0 0 0 .082-.096l.029-.051.027-.081.01-.086V7.336l-.006-.073-.018-.068a.436.436 0 0 0-.124-.178.549.549 0 0 0-.103-.074l-.055-.026-.087-.024-.092-.009h-.579l-.057-.006-.054-.017a.307.307 0 0 1-.096-.07.175.175 0 0 1-.045-.078l-.004-.04.01-.043.022-.043 1.311-2.227.047-.09.037-.106a.492.492 0 0 0-.06-.394.531.531 0 0 0-.255-.22l-.084-.028-.092-.016-.1-.006zm-5.924 0h-.424l-.121.006-.108.018a.552.552 0 0 0-.174.071l-.067.054-.095.1-.084.1-1.429 1.999-.08.12-.096.174a2.798 2.798 0 0 0-.232.677l-.025.142-.024.218L3 7.402v2.646l.008.086.024.08a.486.486 0 0 0 .097.148.468.468 0 0 0 .11.088l.058.028.062.016.065.006h2.543l.065-.006.082-.024a.513.513 0 0 0 .22-.204l.025-.051.024-.081.008-.086V7.336l-.005-.073-.023-.09a.487.487 0 0 0-.191-.23l-.048-.026-.076-.024-.08-.009H5.46l-.05-.006-.047-.017a.273.273 0 0 1-.084-.07.182.182 0 0 1-.04-.078l-.003-.04.008-.043.02-.043L6.411 4.36l.04-.09.033-.106a.553.553 0 0 0-.053-.394.49.49 0 0 0-.222-.22l-.074-.028-.08-.016-.089-.006z"
        />
      </g>
    </svg>
  );
}
